import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-300">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">神马视频</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-400">
              神马视频汇集香蕉视频、红桃视频、蜜桃视频、樱桃视频等水果视频品牌，为您提供海量高清影视内容免费在线观看。每日更新，极速加载，畅享流畅观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">视频品牌</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-50 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors">关于我们</Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-background-400 hover:text-background-50 transition-colors">联系我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-mail-line mt-0.5"></i>
                <span>service@shenmashipin.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-customer-service-line mt-0.5"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>中国 · 北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 神马视频 ShenMaShipin.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}